import type * as React from "react";
import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="skeleton" className={cn("h-3 animate-pulse rounded-md bg-neutral-muted", className)} {...props} />;
}

export { Skeleton };
